import { Accordion, Box, Grid } from "@mantine/core";
import {
  IconBrandAbstract,
  IconBrandArc,
  IconBrandTeams,
} from "@tabler/icons-react";
import ProductCards from "components/products/ProductCards";
import { AboutLandingWrapper } from "pages/AboutUs.styles";
import React from "react";
import MantineComponents from "storybook/MantineComponents";
import Tyopography from "storybook/Typography";
import { COLORS } from "styles/colors";

import { useProductStore } from "stores/useProductStore";

const Playpen: React.FC = () => {
  const getTopSelling = useProductStore((state) => state.getTopSelling);
  const topSelling = getTopSelling();
  const getFeatured = useProductStore((state) => state.getFeatured);
  const featured = getFeatured();
  return (
    <AboutLandingWrapper className="about-us">
      <Accordion defaultValue="Featured">
        <Accordion.Item key={"Featured"} value={"Featured"}>
          <Accordion.Control icon={"🍌"}>
            {"Featured Prdoucts"}
          </Accordion.Control>
          <Accordion.Panel>
            <ProductCards products={featured} title="featured products" />
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"TopSelling"} value={"TopSelling"}>
          <Accordion.Control icon={"🍌"}>{"Top Sellers"}</Accordion.Control>
          <Accordion.Panel>
            <ProductCards products={topSelling} title="top sellers" />
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"Home"} value={"Home"}>
          <Accordion.Control icon={"🍌"}>{"Home Page"}</Accordion.Control>
          <Accordion.Panel>
            <h1>Home Page</h1>
            <div className="section">
              Delicious <span className="section-title">dinner ideas</span>
            </div>
            <table className="border-collapse: collapse; margin-left: auto; margin-right: auto;">
              <tbody>
                <tr>
                  <td className="width: 48.9659%; text-align: center;">
                    <p>
                      <span className="font-size: 20pt;">
                        <em>Inexpensive BBQing</em>
                      </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span className="font-size: 24pt;">Delicious with</span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span className="font-size: 24pt;">
                        <strong>Jumbo Kies &amp; Mix</strong>
                      </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span className="font-size: 24pt;">
                        <strong>grill burgers</strong>
                      </span>
                    </p>
                    <p>&nbsp;</p>
                  </td>
                  <td className="width: 48.9659%;">
                    <img
                      src="images/feature.png"
                      alt="feature"
                      width="771"
                      height="529"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              From here you can see all our products and place your customer
              orders with us... etc etc
            </p>
            <p>&nbsp;</p>
            <p>
              Mike, cant see how to upload product images. I click on the image
              (top right) and all I see is the upload process, I wait and
              nothing happens.&nbsp; Dan
            </p>
            <p>&nbsp;</p> <p>&nbsp;</p>
            <p>Uploading images for detailed/ featured products are done in</p>
            <p>
              <img src="images/hl1.jpg" alt="" width="470" height="193" />
            </p>
            <p>
              <img src="images/hl1.jpg" alt="" width="470" height="193" />
            </p>
            <p>My Account -&gt; Products</p>
            <p>Select Pen icon next to product</p>
            <p>Left image is detailed image</p>
            <p>Right image is featured imae</p> <p>&nbsp;</p>
            <p>
              Click on left or right image -&gt; Choose/browse image on your
              local pc -&gt; Edit product description -&gt; save
            </p>
            <p>&nbsp;</p> <p>Image&nbsp;</p>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"AboutUs"} value={"AboutUs"}>
          <Accordion.Control icon={"🍌"}>{"About Us Page"}</Accordion.Control>
          <Accordion.Panel>
            <Grid gutter="md">
              {/* First row: full width */}
              <Grid.Col span={{ base: 12, sm: 12, md: 12 }}>
                <Box w={550} mx="auto">
                  <h2>Family owned business since 1987</h2>
                  <p>
                    John Jacobson Ltd (JJL Imports) is a family owned business.
                    We started importing food in 1987 with Bolletje Dutch
                    Crispbakes. From this one product we now stock over 1500
                    different lines.
                  </p>
                </Box>
              </Grid.Col>
              {/* Second row: 3 equal columns */}
              <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
                <Box p="md" className="about-us">
                  <IconBrandArc
                    fill={COLORS.colorOrange}
                    size={64}
                    color="#fff"
                  />
                  <p className="about-us-title">What we do</p>
                  <p className="about-us-content ">
                    We stock an extensive range of Biscuits, Cakes, Licorice and
                    Preserves. At JJL we pride ourselves on importing quality
                    products from The Netherlands, Germany and Belgium.
                  </p>
                </Box>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
                <Box p="md" className="about-us">
                  <IconBrandTeams
                    fill={COLORS.colorOrange}
                    size={64}
                    color="#fff"
                  />

                  <p className="about-us-title">Our Team</p>
                  <p className="about-us-content ">
                    Our loyal and talented team help us create nationwide
                    coverage. We are strictly Wholesalers & Distributors and our
                    large range is available from all major Supermarkets and
                    Specialty tores.
                  </p>
                </Box>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
                <Box p="md" className="about-us">
                  <IconBrandAbstract
                    fill={COLORS.colorOrange}
                    size={64}
                    color="#fff"
                  />

                  <p className="about-us-title">Our Brands</p>
                  <p className="about-us-content ">
                    Holland Bakehouse products: Holland Bakehouse products:
                    Stroopie Dutch Syrup Waffles Almond Fingers Almond Rounds
                    Marzipan Cakes Butter Custard Cakes Apple Rounds Cinnamon
                    Squares Butter retzel Cookies Fondant Cakes Coconut Rings.
                  </p>
                </Box>
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"Typography"} value={"Typography"}>
          <Accordion.Control icon={"🍌"}>{"Typography"}</Accordion.Control>
          <Accordion.Panel>
            <Tyopography />
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"Components"} value={"Components"}>
          <Accordion.Control icon={"🍌"}>{"Components"}</Accordion.Control>
          <Accordion.Panel>
            <MantineComponents />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </AboutLandingWrapper>
  );
};
export default Playpen;
